export interface ToolList {
    tool_id?: number;
    category_id?: number;
    type_id?: number;
    brand_id?: number;
    tool_name?: string;
    note?: string | null;
    brand_name?: string;
    brand_color?: string;
    data_id?: number;
    tool_count?: number;
    keep_in: 'On Site' | 'Storage';
    storage_id?: number | null;
    project_id?: number | null;
    location_name?: string;
    editable?: 1 | 0;
}

// to single object maping
export const mapToolList = (data:any): ToolList => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: ToolList ={
        tool_id: data.tool_id,
        category_id: data.category_id,
        type_id: data.type_id,
        brand_id: data.brand_id,
        tool_name: data.tool_name,
        note: data.note,
        brand_name: data.brand_name,
        brand_color: data.brand_color,
        data_id: data.data_id,
        tool_count: data.tool_count,
        keep_in: data.keep_in,
        storage_id: data.storage_id,
        project_id: data.project_id,
        location_name: data.location_name,
        editable: data.editable,
    }
    return res;
}

// maping list objects
export const mapToolLists = (data:any[]): ToolList[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapToolList);
}